import { fetchServer } from "@/features/utils/fetch";
import type { CguType } from "../types";

export class CguApiClient {
  static async getCguList(): Promise<CguType[]> {
    const response = await fetchServer("/public/terms", {
      reloadOn401: false
    });
    if (!response.ok) {
      throw new Error("Error CGU List");
    }
    return await response.json();
  }
}
